import React, { useEffect, useRef, useState } from "react";
import styles from "../../styles/Common.module.css";
import componentStyles from "./tarrot-card-books.module.css";

import bannerCss from "../calendar-of-events/calendarof.module.css";
import Image from "next/image";
import {
  Box,
  LinearProgress,
  Link,
  Modal,
  Snackbar,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import TarrotDetailsModal from "../../components/Modal/TarrotDetailsModal";
import ClothingModal from "../../components/Modal/ClothingModal";
import { useDispatch } from "react-redux";

import CategoryIcon from "@mui/icons-material/Category";
import Head from "next/head";
import { getCookie, setCookie } from "../../components/utils/cookie";
import Carousel from "../../components/CarouselComponent/Carousel";
import SkeletonLoader from "./scaletonloeder"; // Import the skeleton loader
import MysteryBannerNew from "../../components/MysteryBannerNew/MysteryBannerNew";

const Index = ({ data }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const dispatch = useDispatch();

  const [cardData, setCardData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(true);

  const [shopDetails, setShopDetails] = useState("");

  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [openClothingDetailsModal, setOpenClothingDetailsModal] =
    useState(false);
  const [loaderOpen, setLoaderOpen] = useState(false);
  const [snackbarState, setSnackbarState] = useState(false);
  const [snackMsg, setSnackMsg] = useState("");

  const mobileRef = useRef(null);
  const tabletRef = useRef(null);
  const desktopRef = useRef(null);

  const getActiveTarget = () => {
    if (typeof window === "undefined") return null;
    if (window.matchMedia("(min-width: 1024px)").matches) return desktopRef.current;
    if (window.matchMedia("(min-width: 768px)").matches) return tabletRef.current;
    return mobileRef.current;
  };

  const scrollToBookBlock = () => {
    const el = getActiveTarget();
    // console.log(el, "el======>");

    el?.scrollIntoView({ behavior: "smooth", block: "start" });
  };


  useEffect(() => {
    if (data) {
      for (let i in data.results.res) {
        data.results.res[i] = { ...data.results.res[i], productShow: 10 };
      }

      console.log("data============>", data.results.res);
      setCardData(data.results.res);

      setTimeout(() => {
        fetchProductsByCategory();
      }, 500);
    }
  }, [data]);

  useEffect(() => {
    const cookie = getCookie("guest_id");
    console.log(cookie, "================>");
    if (!cookie) {
      console.log("blockhit================>");

      const randomValue =
        Math.random().toString(36).substring(2, 16) +
        Math.random().toString(36).substring(2, 16);
      console.log("randomValue================>", randomValue);

      const expires = new Date();
      expires.setMonth(expires.getMonth() + 2);

      setCookie("guest_id", randomValue, { expires });
      console.log("setCookie================>", randomValue, expires);
    }
    scrollToBookBlock()
  }, []);

  const fetchProductsByCategory = async () => {
    try {
      // setIsLoading(true);

      let categoriesRes = await fetch(
        `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}product-category/rest-categories`
      );
      categoriesRes = await categoriesRes.json();

      console.log("categoriesRes before", categoriesRes);
      let array = [];

      for (let category of categoriesRes.results.res) {
        console.log("categoriesRes", category);
        let categoryId = category._id;
        let productRequestBody = {
          condition: {
            limit: 10,
          },
          searchcondition: {
            _id: categoryId,
          },
        };

        let productsData = await fetch(
          `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}product-category/product-category-list-By-category-id`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(productRequestBody),
          }
        );

        productsData = await productsData.json();
        console.log("productsData=============", productsData);

        if (
          productsData.status == "success" &&
          productsData.results.res[0].product_list.length > 0
        ) {
          console.log(
            "cardData=============>2",
            productsData.results.res.length
          );

          setCardData((prevCardData) => [
            ...prevCardData,
            { ...productsData.results.res[0], productShow: 10 },
          ]);
          console.log(" array=============>", cardData, array);
        }
      }

      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching products:", error);
      setIsLoading(false);
    }
  };

  const openDetails = async (data) => {
    setLoaderOpen(true);

    let detailsBody = {
      product_id: data._id,
      user_id: getCookie("user_id")
        ? getCookie("user_id")
        : getCookie("guest_id"),
    };

    let detailsData = await fetch(
      `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}cart_management/get-product-detail-for-user`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(detailsBody),
      }
    );

    detailsData = await detailsData.json();
    console.log("detailsData", detailsData);

    if (detailsData.status == "success") {
      setShopDetails(detailsData);
      setLoaderOpen(false);
      if (data.printify_category) {
        setOpenClothingDetailsModal(true);
      } else {
        setOpenDetailsModal(true);
      }
    } else {
      setSnackbarState(true);
      setSnackMsg("Something went wrong !!");
      setLoaderOpen(false);
    }
  };

  useEffect(() => {
    console.log("openClothingDetailsModal", openClothingDetailsModal);
  }, [openClothingDetailsModal]);

  const loadMore = async (value) => {
    console.log(" value=============>", value);
    setIsLoadingMore(true);
    let newLimit = value.productShow + 10;

    let productRequestBody = {
      condition: {
        limit: newLimit,
      },
      searchcondition: {
        _id: value._id,
      },
    };

    try {
      let productsData = await fetch(
        `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}product-category/product-category-list-By-category-id`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(productRequestBody),
        }
      );

      productsData = await productsData.json();

      console.log("productsData", productsData);
      for (let i in cardData) {
        if (cardData[i]._id == value._id) {
          console.log("inside loop", cardData[i]);

          const newCardData = [...cardData];
          console.log("inside loop newCardData", newCardData);

          let newProductList = productsData.results.res[0];
          newCardData[i] = { ...newProductList, productShow: newLimit };
          console.log("newCardData[i]", newCardData[i]);

          setCardData(newCardData);
          setIsLoadingMore(false);
        }
      }
    } catch (error) {
      console.error("Error loading more products:", error);
      setIsLoadingMore(false);
    }
  };

  const closeSnack = () => {
    setSnackbarState(false);
  };

  const AmazonIcon = ({
    width = 24,
    height = 24,
    color = "currentColor",
    ...props
  }) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
        width={width}
        height={height}
        fill={color}
        {...props}
      >
        <path d="M257.2 162.7c-48.7 1.8-169.5 15.5-169.5 117.5 0 109.5 138.3 114 183.5 43.2 6.5 10.2 35.4 37.5 45.3 46.8l56.8-56S341 288.9 341 261.4V114.3C341 89 316.5 32 228.7 32 140.7 32 94 87 94 136.3l73.5 6.8c16.3-49.5 54.2-49.5 54.2-49.5 40.7-.1 35.5 29.8 35.5 69.1zm0 86.8c0 80-84.2 68-84.2 17.2 0-47.2 50.5-56.7 84.2-57.8v40.6zm136 163.5c-7.7 10-70 67-174.5 67S34.2 408.5 9.7 379c-6.8-7.7 1-11.3 5.5-8.3C88.5 415.2 203 488.5 387.7 401c7.5-3.7 13.3 2 5.5 12zm39.8 2.2c-6.5 15.8-16 26.8-21.2 31-5.5 4.5-9.5 2.7-6.5-3.8s19.3-46.5 12.7-55c-6.5-8.3-37-4.3-48-3.2-10.8 1-13 2-14-.3-2.3-5.7 21.7-15.5 37.5-17.5 15.7-1.8 41-.8 46 5.7 3.7 5.1 0 27.1-6.5 43.1z" />
      </svg>
    );
  };

  const goToAmazon = () => {
    window.open(
      "https://www.amazon.in/Being-Gods-Christian-Deification-Restoration/dp/0965299651/ref=sr_1_1?crid=37YP9A9X8DZ74&dib=eyJ2IjoiMSJ9.M8M2yD_IMfEy7m0ncPxbpHOohlA9IhA4VBzZZNjtGVYm24ejK0-6Mk-neRrvm3sCPJcFr6H74iQZOHrtxrWqYAs7dFZOUvb8rzpKy6efPEOQR1qsD6As9bmL1qgTs90di3cxFuCECfK7K0N4ki2Q6o7cYq_xvSYCwzQ_4gWkMt3d_VurNtJuNWL_go36uZREGvT5WrzzaKiBtXaP_w0bcQ9F2hFFyCrZPGyB9MKxDF4.Qb6Z4vZAKA9vQExCldrtFysM5nWJpRNF3WxWFxJ3RAg&dib_tag=se&keywords=divine+infinite+being+book&qid=1731067280&sprefix=%2Caps%2C253&sr=8-1",
      "_blank"
    );
  };

  // << ------------- Book Flip -------------------- >>

  const cards = [
    {
      title: "Past Influences",
      image: "/tarot-card-images/Domonion_Small.jpg",
      price: "$19.99",
      details:
        "Past influences shape present perspectives, guiding future endeavors.",
      carousel: [
        "/tarot-card-images/Domonion_Small.jpg",
        "/tarot-card-images/orphic-jung-tarot_title_image7.png",
        "/tarot-card-images/hermit.jpg",
      ],
    },
    // ... other cards
  ];

  // << ------------- Carousel Data ------------- >>

  const slidesData = [
    {
      image: "/image/book-1.jpg",
      title: "THE SPIRIT OF THE HEALTH",
      subtitle: "THE BEST EXCLUSIVE OFFER!",
      description: "NOW! GET UP TO 60% OFF",
      buttonText: "SHOP NOW",
      redirectUrl: "/grocery-items",
    },
    {
      image: "/image/book-2.jpg",
      title: "FRESH & ORGANIC FOODS",
      subtitle: "SPECIAL DISCOUNTS TODAY!",
      description: "UP TO 50% OFF ON ALL PRODUCTS",
      buttonText: "SHOP NOW",
      redirectUrl: "/fresh-vegetables",
    },
    {
      image: "/image/book-3.jpg",
      title: "THE SPIRIT OF THE HEALTH",
      subtitle: "THE BEST EXCLUSIVE OFFER!",
      description: "NOW! GET UP TO 60% OFF",
      buttonText: "SHOP NOW",
      redirectUrl: "/grocery-items",
    },
  ];

  if (isLoading) {
    return (
      <>
        <Head>
          <title>
            INFINITE BEING: Your Gateway to Divine Theurgy & Mystical Tools
          </title>
          <meta charSet="UTF-8" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />

          <meta
            name="description"
            content="INFINITE BEING: Explore Polytheistic Monism, Divine Theurgy, and Oracle readings. We train Astrologers, Tarot readers, and offer a Mystery School for modern ritual Theurgy. Shop our unique Tarot decks, posters, apparel, and more."
          />
          <meta
            name="keywords"
            content="Tarot, Astrology, Theurgy, Mystery School, Divination, Occult, Spirituality, Religion, Perennial Mandalism, Tarot decks, Posters, Apparel"
          />

          <meta
            property="og:title"
            content="Shop | School of Our Divine Infinite Being"
          />
          <meta property="og:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/TranscendentOG_image.webp" />
          <meta property="og:type" content="website" />
          <meta
            property="og:url"
            content="https://www.divineinfinitebeing.com/shop"
          />
          <meta
            property="og:image:alt"
            content="Divine Infinite Being Shop page featuring a collection of spiritual and holistic products, including crystals, meditation tools, and wellness guides, set against a serene background of soft, pastel hues and nature-inspired elements."
          />
          <meta
            property="og:description"
            content="INFINITE BEING: Explore Polytheistic Monism, Divine Theurgy, and Oracle readings. We train Astrologers, Tarot readers, and offer a Mystery School for modern ritual Theurgy. Shop our unique Tarot decks, posters, apparel, and more."
          />
          <meta property="og:site_name" content="DIVINE INFINITE BEING" />
          <meta property="og:locale" content="en_US" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta
            property="twitter:title"
            content="INFINITE BEING: Your Gateway to Divine Theurgy & Mystical Tools"
          />
          <meta
            property="twitter:image"
            content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/rota-the-wheel/TranscendentOG_image.webp"
          ></meta>
          <meta
            property="twitter:url"
            content="https://www.divineinfinitebeing.com/shop"
          />
          <meta
            property="twitter:description"
            content="INFINITE BEING: Explore Polytheistic Monism, Divine Theurgy, and Oracle readings. We train Astrologers, Tarot readers, and offer a Mystery School for modern ritual Theurgy. Shop our unique Tarot decks, posters, apparel, and more."
          />
          <meta
            property="twitter:image:alt"
            content="Divine Infinite Being Shop page featuring a collection of spiritual and holistic products, including crystals, meditation tools, and wellness guides, set against a serene background of soft, pastel hues and nature-inspired elements."
          />
          <link rel="canonical" href="https://www.divineinfinitebeing.com/shop" />
        </Head>

        <div className={bannerCss.ochema_ritual_blockone}>
          <div className={bannerCss.ochema_ritual_banner_main_wrpr}>
            <div className={bannerCss.ochema_ritual_banner_left}>
              <div className={bannerCss.bannerLogo}>
                <span className={bannerCss.logoviewlink} onClick={handleOpen}>
                  <img
                    src={`${process.env.cloud_url2}assets/images/viewicon.png`}
                    alt="view icon"
                  />
                </span>
                <img
                  src={`${process.env.cloud_url2}assets/images/logobanner.webp`}
                  alt="logo banner"
                />
              </div>
              <h1 ref={desktopRef} data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE</h1>
              <h1 data-text="infinite being">INFINITE BEING</h1>
              <h2>Polytheistic Monism - Divine Theurgy - Oracle to the Gods</h2>
              <div
                className={`${bannerCss.ochema_ritual_bottombannerbg} ${bannerCss.bannerboxtxt}`}
              >
                <div className={bannerCss.yellow_bar}></div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`${styles.shop_mainwrapper} ${componentStyles.tarrot_cardbooks_wrapper}`}
          ref={tabletRef}

        >
          <div
            className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
          >
            <span className={styles.column}>
              <div className={`${styles.col12} ${styles.bgifive}`}>
                <h1>
                  EMBARK ON A MYSTICAL JOURNEY THROUGH TAROT, ASTROLOGY &
                  SPIRITUAL ARTS
                </h1>
                <p ref={mobileRef}>
                  Unveil the universe's hidden wisdom with our curated
                  collection of tarot cards, astrology books, celestial posters,
                  and unique spiritual merchandise. Whether you're a seasoned
                  seeker or a curious soul, discover the perfect treasures to
                  illuminate your spiritual path.
                </p>
              </div>
            </span>
          </div>

          <SkeletonLoader />

          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="banner_modal_main"
          >
            <Box className="banner_modal_box">
              <Typography
                id="modal-modal-description"
                component="div"
                sx={{ mt: 2 }}
                className="modal_banner"
              >
                <div className="sub_modal_banner">
                  <span className="close_btn" onClick={handleClose}>
                    <CloseIcon />
                  </span>
                  <img
                    src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp"
                    alt="bannerLogo"
                  />
                </div>
              </Typography>
            </Box>
          </Modal>
        </div>
      </>
    );
  }

  return (
    <>
      <Head>
        <title>
          INFINITE BEING: Your Gateway to Divine Theurgy & Mystical Tools
        </title>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta
          property="og:title"
          content="Shop | School of Our Divine Infinite Being"
        ></meta>
        <meta
          name="description"
          content="INFINITE BEING: Explore Polytheistic Monism, Divine Theurgy, and Oracle readings. We train Astrologers, Tarot readers, and offer a Mystery School for modern ritual Theurgy. Shop our unique Tarot decks, posters, apparel, and more."
        />
        <meta
          name="keywords"
          content="Tarot, Astrology, Theurgy, Mystery School, Divination, Occult, Spirituality, Religion, Perennial Mandalism, Tarot decks, Posters, Apparel"
        />

        <meta
          property="og:title"
          content="INFINITE BEING: Your Gateway to Divine Theurgy & Mystical Tools"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/shop"
        />
        <meta
          property="og:image:alt"
          content="Divine Infinite Being Shop page featuring a collection of spiritual and holistic products, including crystals, meditation tools, and wellness guides, set against a serene background of soft, pastel hues and nature-inspired elements."
        ></meta>
        <meta
          property="og:description"
          content="INFINITE BEING: Explore Polytheistic Monism, Divine Theurgy, and Oracle readings. We train Astrologers, Tarot readers, and offer a Mystery School for modern ritual Theurgy. Shop our unique Tarot decks, posters, apparel, and more."
        />
        <meta property="og:site_name" content="DIVINE INFINITE BEING" />
        <meta property="og:locale" content="en_US" />

        <meta
          property="twitter:image:alt"
          content="Divine Infinite Being Shop page featuring a collection of spiritual and holistic products, including crystals, meditation tools, and wellness guides, set against a serene background of soft, pastel hues and nature-inspired elements."
        ></meta>
        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:title"
          content="INFINITE BEING: Your Gateway to Divine Theurgy & Mystical Tools"
        ></meta>
        <meta
          property="twitter:url"
          content="https://www.divineinfinitebeing.com/shop"
        ></meta>
        <meta
          property="twitter:description"
          content="INFINITE BEING: Explore Polytheistic Monism, Divine Theurgy, and Oracle readings. We train Astrologers, Tarot readers, and offer a Mystery School for modern ritual Theurgy. Shop our unique Tarot decks, posters, apparel, and more."
        ></meta>
      </Head>

      <div className={bannerCss.ochema_ritual_blockone}>
        <div className={bannerCss.ochema_ritual_banner_main_wrpr}>
          <div className={bannerCss.ochema_ritual_banner_left}>

            <div className={bannerCss.bannerLogo} >
              <span className={bannerCss.logoviewlink} onClick={handleOpen}>
                <img
                  src={`${process.env.cloud_url2}assets/images/viewicon.png`}
                />
              </span>
              <img
                src={`${process.env.cloud_url2}assets/images/logobanner.webp`}
              />
            </div>
            <h1 ref={desktopRef} data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE </h1>
            <h1 data-text="infinite being">INFINITE BEING</h1>

            <h2>Polytheistic Monism - Divine Theurgy - Oracle to the Gods</h2>
            <div
              className={`${bannerCss.ochema_ritual_bottombannerbg} ${bannerCss.bannerboxtxt}`}
            >
              <div className={bannerCss.yellow_bar}></div>
            </div>
          </div>
        </div>
      </div>

      <MysteryBannerNew/>

      <div
        className={`${styles.shop_mainwrapper} ${componentStyles.tarrot_cardbooks_wrapper}`}
        ref={tabletRef}
      >
        <div
          className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}

        >
          <span className={styles.column}>
            <div className={`${styles.col12} ${styles.bgifive}`}>
              <h1>
                EMBARK ON A MYSTICAL JOURNEY THROUGH TAROT, ASTROLOGY &
                SPIRITUAL ARTS
              </h1>
              <p ref={mobileRef}>
                Unveil the universe&apos;s hidden wisdom with our curated
                collection of tarot cards, astrology books, celestial posters,
                and unique spiritual merchandise. Whether you&apos;re a seasoned
                seeker or a curious soul, discover the perfect treasures to
                illuminate your spiritual path.
              </p>
            </div>
          </span>
        </div>

        <div className={styles.gallery_wrapper}  >
          <div
            className={`${styles.carousel_card_wrapper} ${styles.carousel_card_wrapper2} ${styles.carousel_card_wrapper3}`}
          >
            {/* <div className={styles.cards_container}>
              <Link href="/divine-arcana-tarots">
                <div className={`${styles.card} ${styles.grocery}`}>
                  <Image
                    src="/image/tarrot-card-temp.jpeg"
                    alt="Tarrot Card"
                    width={400}
                    height={250}
                  />
                </div>
              </Link>
              <Link href="/shop/posters">
                <div className={`${styles.card} ${styles.vegetables}`}>
                  <Image
                    src="/image/poster-temp.jpeg"
                    alt="Poster"
                    width={400}
                    height={250}
                  />
                </div>
              </Link>
            </div> */}
            <div className={styles.full_yellow_clr_main_wrp}>
              <div className={styles.full_yellow_clr_main_sec_wrp}>
                <h3>
                  <samp>full color</samp> <br />
                  <samp>divine arcana</samp> <br />
                  <span>tarot</span>
                </h3>
              </div>
              <Link href="/divine-arcana-tarots">
                <button>shop now</button>
              </Link>
            </div>
          </div>
          {cardData &&
            cardData.map((card, index) => {
              console.log(card, "card======>");

              return card.title === "Books" ? (
                <div key={index}>
                  <div
                    className={`${styles.carousel_card_wrapper} ${styles.carousel_card_wrapper2}`}
                  >
                    <div className={styles.carousel_wrapper}>
                      <Carousel
                        slides={card.product_list}
                        autoPlayInterval={5000}
                      />
                    </div>
                    {/* <div className={styles.cards_container}>
                      <Link href="/divine-arcana-tarots">
                        <div className={`${styles.card} ${styles.grocery}`}>
                          <Image
                            src="/image/tarrot-card-temp.jpeg"
                            alt="Tarrot Card"
                            width={400}
                            height={250}
                          />
                        </div>
                      </Link>

                      <Link href="/shop/posters">
                        <div className={`${styles.card} ${styles.vegetables}`}>
                          <Image
                            src="/image/poster-temp.jpeg"
                            alt="Poster"
                            width={400}
                            height={250}
                          />
                        </div>
                      </Link>
                    </div> */}
                  </div>
                </div>
              ) : (
                <div key={index} className={styles.gallery}>
                  <div className={styles.category_wrapper}>
                    <h2>
                      <CategoryIcon /> {card.title}
                    </h2>
                  </div>
                  <div className={styles.gallery__column}>
                    {card.product_list.map((product) => {
                      console.log("product++++", product);
                      const imageWithStatusTrue = product.image.find((img) =>
                        img.flds?.find(
                          (fld) =>
                            fld.key === "img_status" && fld.value === true
                        )
                      );
                      const imageUrl = `${process.env.NEXT_PUBLIC_IMG_URL3}${imageWithStatusTrue?.baseurl}${imageWithStatusTrue?.fileservername}`;

                      console.log(imageUrl, "imageUrl======>");

                      return (
                        <React.Fragment key={product._id}>
                          {!product.printify_category ? (
                            <a className={styles.gallery__link}>
                              <div className={styles.tarrot_heading_wrap}>
                                <p>
                                  <span>Price: $</span>
                                  {product.mrp}
                                </p>
                                <button onClick={() => openDetails(product)}>
                                  Click for Details
                                </button>
                              </div>
                              <figure className={styles.gallery__thumb}>
                                <img
                                  className={styles.gallery__image}
                                  src={imageUrl}
                                  alt={product.name}
                                  onClick={() => openDetails(product)}
                                />
                              </figure>
                            </a>
                          ) : (
                            <div
                              className={styles.gallery__link}
                              onClick={() => openDetails(product)}
                            >
                              <div className={styles.image_sec_main}>
                                <div className={styles.gallery__thumb}>
                                  <img
                                    className={styles.gallery__image}
                                    src={product.images[0].src}
                                    alt={product.name}
                                  />
                                </div>
                              </div>
                              <div className={styles.product_details_sec}>
                                <h2 className={styles.product_heading}>
                                  {product.name}
                                </h2>
                                <h1 className={styles.product_price}>
                                  From USD {product.mrp}
                                </h1>
                                <h1 className={styles.product_discount_price}>
                                  <span>
                                    From USD {product.offer_price} with Printify
                                    Premium
                                  </span>
                                </h1>
                                <h5 className={styles.product_collection}>
                                  <span>{product.total_size_option} sizes</span>{" "}
                                  -
                                  <span>
                                    {product.total_color_option} colors
                                  </span>{" "}
                                  -
                                  <span>
                                    {product.total_variants_option} print
                                    variants
                                  </span>
                                </h5>
                              </div>
                            </div>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </div>
                  {card.product_count > 10 &&
                    card.product_count > card.productShow && (
                      <div className={styles.card_loadmore}>
                        <button
                          onClick={() => loadMore(card)}
                          disabled={isLoadingMore}
                        >
                          {isLoadingMore ? "Loading..." : "Load More"}
                        </button>
                      </div>
                    )}
                </div>
              );
            })}
          <div></div>
        </div>
      </div>

      {openDetailsModal ? (
        <TarrotDetailsModal
          openDetailsModal={openDetailsModal}
          setOpenDetailsModal={setOpenDetailsModal}
          shopDetails={shopDetails}
        />
      ) : (
        ""
      )}

      {openClothingDetailsModal ? (
        <ClothingModal
          openClothingDetailsModal={openClothingDetailsModal}
          setOpenClothingDetailsModal={setOpenClothingDetailsModal}
          shopDetails={shopDetails}
        />
      ) : (
        ""
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="banner_modal_main"
      >
        <Box className="banner_modal_box">
          <Typography
            id="modal-modal-description"
            component="div"
            sx={{ mt: 2 }}
            className="modal_banner"
          >
            <div className="sub_modal_banner">
              <span className="close_btn" onClick={handleClose}>
                <CloseIcon />
              </span>
              <img
                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp"
                alt="bannerLogo"
              />
            </div>
          </Typography>
        </Box>
      </Modal>

      <Modal
        open={loaderOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="linear_loader_modalbox">
          <LinearProgress sx={{ margin: "0px" }} />
        </Box>
      </Modal>

      <Snackbar
        open={snackbarState}
        autoHideDuration={3000}
        onClose={() => closeSnack()}
        className="snackbarClass"
        message={snackMsg}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        bodyStyle={{ backgroundColor: "teal", color: "coral" }}
      />
    </>
  );
};

export default Index;

export const getServerSideProps = async (context) => {
  let rep = await fetch(
    `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}product-category/product-management-list-category-wise-first-two`
  );
  rep = await rep.json();

  console.log("rep----------------12345", rep);

  return { props: { data: rep } };
};
